import React, { useEffect, useRef, useState } from 'react';

export function AudioBars({ audioTrack, isActive, color = "#3b82f6" }) {
  const [bars, setBars] = useState(Array(16).fill(4));
  const analyserRef = useRef(null);
  const animRef     = useRef(null);
  const ctxRef      = useRef(null);

  useEffect(() => {
    if (!audioTrack || !isActive) {
      const idle = setInterval(() => {
        setBars(prev => prev.map((_, i) =>
          4 + Math.sin(Date.now() / 400 + i * 0.5) * 3
        ));
      }, 50);
      return () => clearInterval(idle);
    }

    try {
      const ctx      = new AudioContext();
      ctxRef.current = ctx;
      const src      = ctx.createMediaStreamSource(new MediaStream([audioTrack]));
      const analyser = ctx.createAnalyser();
      analyser.fftSize = 64;
      src.connect(analyser);
      analyserRef.current = analyser;
      const data = new Uint8Array(analyser.frequencyBinCount);

      const draw = () => {
        analyser.getByteFrequencyData(data);
        const step = Math.floor(data.length / 16);
        setBars(Array.from({ length: 16 }, (_, i) => {
          const v = data[i * step] / 255;
          return 4 + v * 80;
        }));
        animRef.current = requestAnimationFrame(draw);
      };
      draw();
    } catch (_) {}

    return () => {
      cancelAnimationFrame(animRef.current);
      try { ctxRef.current?.close(); } catch (_) {}
    };
  }, [audioTrack, isActive]);

  return (
    <div style={{
      display: "flex", alignItems: "center",
      justifyContent: "center", gap: "4px", height: "100px",
    }}>
      {bars.map((h, i) => (
        <div key={i} style={{
          width: "8px",
          height: `${Math.max(4, h)}px`,
          borderRadius: "4px",
          background: isActive
            ? `hsl(${210 + i * 4}, 80%, 60%)`
            : color,
          transition: "height 0.05s ease",
          opacity: isActive ? 1 : 0.35,
          boxShadow: isActive ? `0 0 8px hsl(${210 + i * 4}, 80%, 60%)44` : 'none',
        }} />
      ))}
    </div>
  );
}
